import React from 'react'
import createSvgIcon from '../createSvgIcon'

export default createSvgIcon(
  <>
    <defs>
      <linearGradient
        id="infoGradient"
        x1="12"
        y1="0"
        x2="12"
        y2="24"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#768EDD" />
        <stop offset="1" stopColor="#1A42C6" />
      </linearGradient>
    </defs>
    <rect width="24" height="24" rx="6" fill="url(#infoGradient)" />
    <path
      d="M12 9C12.5523 9 13 8.55228 13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8C11 8.55228 11.4477 9 12 9Z"
      fill="white"
    />
    <path
      d="M12 10.333C11.4 10.333 11 10.813 11 11.533V15.133C11 15.853 11.4 16.333 12 16.333C12.6 16.333 13 15.853 13 15.133V11.533C13 10.813 12.6 10.333 12 10.333Z"
      fill="white"
    />
  </>,
  'Info',
  24
)
